import {HomePage,  ProfilePage} from './pages';
import Kullanici from "./pages/tanim/kullanici/kullanici";
import TesvikIslemleri from "./pages/tesvik/TesvikIslemleri";
import BildirgeIslemleri from "./pages/bildirge/BildirgeIslemleri";
import YaklasikHesap from "./pages/yaklasikhesap/YaklasikHesap";
import KurumPersonelDetay from "./pages/kurumpersoneldetay/KurumPersonelDetay";
import TesvikDetayIslemleri from "./pages/tesvikdetay/TesvikDetayIslemleri";
import TesvikRaporIslemleri from "./pages/tesvikrapor/TesvikRaporIslemleri";

import TesvikFarkRapor from "./pages/tesvikraporfark/TesvikFarkRapor";
import TesvikRaporBilgi from "./pages/tesvikraporbilgi/TesvikRaporBilgi";
import CariDonemRapor from "./pages/caridonem/CariDonemRapor";
import CariDonemFinansRapor from "./pages/caridonemfinansrapor/CariDonemFinansRapor";
import SeleniumRemote from "./pages/tanim/seleniumremote/SeleniumRemote";
import RolKullaniciGrup from "./pages/tanim/rolkullanicigrup/RolKullaniciGrup";
import Domain from "./pages/tanim/domain/Domain";
import RoleGroup from "./pages/tanim/rolegroup/RoleGroup"; 
import TesvikKanunu from "./pages/tanim/tesvikkanunu/TesvikKanunu";

import SgkIslemleri from "./pages/sgkislemleri/SgkIslemleri";

import RaporUcretIslemleri from "./pages/raporucretiislemleri/RaporUcretIslemleri"

import PotansiyelTesvikSorgulama from "./pages/potansiyeltesviksorgulama/PotansiyelTesvikSorgulama"

import MaasOrtalamaRapor from "./pages/yoneticirapor/MaasOrtalamaRapor";

import AsgariUcretRaporFark from "./pages/asgariucretraporfark/AsgariUcretRaporFark";

import ParolaDegistir from "./pages/paroladegistir/ParolaDegistir";

export default [
    {
        path: '/profile',
        component: ProfilePage
    },
    {
        path: '/parolaDegistir',
        component: ParolaDegistir
    },
    {
        path: '/home',
        component: HomePage
    },
        
    {
        path: '/maasOrtalamaRapor',
        component: MaasOrtalamaRapor
    } ,
    {
        path: '/kullanici',
        component: Kullanici
    }, 
    {
        path: '/sgkislem',
        component: SgkIslemleri
    },
    {
        path: '/raporucretislemileri',
        component: RaporUcretIslemleri
    },
    {
        path: '/potansiyeltesviksorgulama',
        component: PotansiyelTesvikSorgulama
    },
    {
        path: '/tesvik',
        component: TesvikIslemleri
    },
    {
        path: '/tesvikDetay',
        component: TesvikDetayIslemleri
    },
    {
        path: '/tesvikRapor',
        component: TesvikRaporIslemleri
    },
    {
        path: '/tesvikRaporFark',
        component: TesvikFarkRapor
    },
    {
        path: '/tesvikRaporBilgi',
        component: TesvikRaporBilgi
    },
    
    {
        path: '/asgariUcretRaporFark',
        component: AsgariUcretRaporFark
    },
    {
        path: '/cariDonemRapor',
        component: CariDonemRapor
    }, 
    {
        path: '/cariDonemFinansRapor',
        component: CariDonemFinansRapor
    }, 
    {
        path: '/bildirge',
        component: BildirgeIslemleri
    }

    ,{
        path: '/firma',
        component: Domain
    },
    {
        path: '/roleGroup',
        component: RoleGroup
    },
    {
        path: '/tesviktanimi',
        component: TesvikKanunu
    },
    {
        path: '/yaklasikHesap',
        component: YaklasikHesap
    }    ,
    {
        path: '/personelDetay',
        component: KurumPersonelDetay
    } ,
    {
        path: '/seleniumRemote',
        component: SeleniumRemote
    },
    {
        path: '/rolKullaniciGrup',
        component: RolKullaniciGrup
    } ,
    {
        path: '/',
        component: HomePage
    } 
];
